import { CloseButton, Collapse, Group, Text, UnstyledButton } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getRobot, useBot } from '@mygpt/app';
import { ModalWidget } from '@/components/Widget/Embed/Code';

const WidgetInstallTip = () => {
  const { t } = useTranslation();
  const { botId } = useBot();

  const [opened, setOpened] = useState(false);
  const [openedWidget, { close: closeWidget, open: openWidget }] = useDisclosure(false);

  const init = async () => {
    const res = await getRobot({ aiId: botId });
    const { configs } = res.data;
    if (!configs || !configs.client_installed) setOpened(true);
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <Collapse in={opened}>
        <Group
          justify="space-between"
          className="flex items-center bg-[#FEC84B] py-3 px-5 rounded-[8px] shadow-lg"
          mb={40}
        >
          <Text size="sm">{t('dashboard.widget_install_tip')}</Text>
          <Group className="space-x-3">
            <UnstyledButton
              className="text-sm bg-white hover:bg-[#fbeed0] active:bg-[#ffe9b7] text-[#F79009] rounded-[8px] px-[8px] py-[4px]"
              onClick={openWidget}
            >
              {t('dashboard.install')}
            </UnstyledButton>
            <CloseButton
              aria-label="Close modal"
              className="text-[#F79009] bg-white hover:bg-[#fbeed0] active:bg-[#ffe9b7] rounded-full"
              onClick={() => setOpened((o) => !o)}
            />
          </Group>
        </Group>
      </Collapse>
      <ModalWidget opened={openedWidget} close={closeWidget} hideSetting />
    </>
  );
};

export default WidgetInstallTip;
